import React, { Component } from "react";
import CompanyTagEdit from "./CompanyTagEdit";

import AuthContext from "../../../../AuthContext";
import mtzApis from "../../../../services";
const { companyService } = mtzApis;

class CompanyTagManager extends Component {
  constructor(props) {
    super(props);
    this.state = {
      company: null
    };
    this.editTagModalRef = React.createRef();
  }

  componentDidMount() {
    this.init();
  }

  componentDidUpdate(prevProps) {
    if (this.props !== prevProps)
      this.init();
  }

  init = async () => {
    const { profileName } = this.props;
    const companies = await companyService.getCompanies(new URLSearchParams(`profileName=${encodeURIComponent(profileName)}`));
    let company = companies.length > 0 ? companies[0] : null;
    if (company)
      this.setState({ company });
  }

  updateCompany = async changes => {
    const { company } = this.state;

    mtzApis.startSpinningIcon();
    const updated = await companyService.updateCompanyById(this.state.company.id, changes);
    mtzApis.stopSpinningIcon();

    if (!updated) return;

    if (changes.hasOwnProperty("sku"))
      window.history.replaceState(null, null, `/companies/${company.profileName}/${updated.sku}`)

    this.setState({ company: updated });
  }

  render() {
    const { company } = this.state;
    const { me } = this.props;

    return (
      <div>
        <div className="mtz-card" elevation={0}>
          <h5 className="">Company Tag(s)</h5>

          <div className="d-flex mtz-gap-4 flex-wrap">
            {
              company && company.companyTags && company.companyTags.length > 0 ?
                company.companyTags.map(companyTag => {
                  return (
                    <span
                      key={companyTag}
                      className="btn-sm btn btn-outline-primary"
                    >#{companyTag}</span>);
                }) :
                <div>No company tags selected.</div>
            }
          </div>

          {me && company && company && me.userId === company.ownerId && (
            <div className="w-100">
              <div className="text-right">
                <button data-toggle='modal' data-target='#edit-tag-modal'
                  className="btn btn-sm btn-link">
                  Edit tags <span className="fa fa-edit"></span>
                </button>
              </div>

              <div id='edit-tag-modal' className="modal">
                <div className="modal-dialog modal-dialog-scrollable">
                  <div className="modal-content">
                    <div className="modal-header d-flex">
                      <h5 className="mtz-h5 flex-fill">Edit Company Tag(s)</h5>

                      <button ref={this.editTagModalRef} className="btn btn-sm close" data-dismiss='modal'>
                        <span className="fa fa-close"></span>
                      </button>
                    </div>

                    <div className="modal-body">
                      <CompanyTagEdit
                        onChange={this.updateCompany}
                        companyTags={company && company.companyTags} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )

          }

        </div>
      </div>
    );
  }

}

export default props => (
  <AuthContext.Consumer>
    {
      val => <CompanyTagManager {...props} me={val} />
    }
  </AuthContext.Consumer>
);